import React from "react";
import { NotificationCategory } from "../../Constants/Enums/Notification.enum";
import { Colors } from "../../Constants/colors";
import GeneralNotificationIcon from "./../../images/megaphone-icon.svg";
import BillingNotificationIcon from "./../../images/billing-icon.svg";
import AcademicNotificationIcon from "./../../images/academic-icon.svg";
import PromotionalNotificationIcon from "./../../images/promotional-icon.svg";
import EventsNotificationIcon from "./../../images/events-icon.svg";

interface Props {
  title?: string;
  text: string;
  category: NotificationCategory;
  isSeen?: boolean;
  createdAgo: string;
}

export const Notification = ({
  title,
  text,
  category,
  isSeen = false,
  createdAgo,
}: Props) => {
  const notficationIcon = () => {
    switch (category) {
      case NotificationCategory.GENERAL:
        return GeneralNotificationIcon;
      case NotificationCategory.BILLING:
        return BillingNotificationIcon;
      case NotificationCategory.ACADEMIC:
        return AcademicNotificationIcon;
      case NotificationCategory.PROMITION:
        return PromotionalNotificationIcon;
      case NotificationCategory.EVENTS:
        return EventsNotificationIcon;
      default:
        return GeneralNotificationIcon;
    }
  };
  return (
    <div
      className="flex flex-col gap-1 pt-4 pb-4 pl-4 pr-4"
      style={{
        borderBottom: `1px solid  ${Colors.LightAshRose}`,
        backgroundColor: Colors.WhiteSmoke,
      }}
    >
      <div className="flex gap-4">
        <img
          src={notficationIcon()}
          alt="notification-icon"
          style={{
            height: "30px",
            width: "30px",
            marginTop: "8px",
          }}
        />
        <div>
          <h1 className="text-lg font-bold">{title}</h1>
          <p className="text-sm">{text}</p>
          <p style={{ color: Colors.BurgundyRed, fontSize: "10px" }}>
            {createdAgo}
          </p>
        </div>
      </div>
    </div>
  );
};
